<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">{{dialogTitle | translate}}</span>
            <button mat-icon-button (click)="matDialogRef.close()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-8 m-0" fusePerfectScrollbar>

        <form autocomplete="off" [formGroup]="recommenderForm">

            <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field appearance="outline" fxFlex>
                    <mat-label>{{'First Name' | translate }}</mat-label>
                    <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                    <input name="first_name" formControlName="first_name" matInput required>
                    <mat-error *ngIf="checkServerError('first_name')"> {{checkServerError('first_name')}}</mat-error>
                </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field appearance="outline" fxFlex>
                    <mat-label>{{'Last Name' | translate }}</mat-label>
                    <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                    <input name="last_name" formControlName="last_name" matInput required>
                    <mat-error *ngIf="checkServerError('last_name')"> {{checkServerError('last_name')}}</mat-error>
                </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutAlign="start start" class="telephone">
                <mat-form-field appearance="outline" fxFlex>
                    <mat-label>{{'Phone number' | translate }}</mat-label>
                    <tel-input name="phone_number" formControlName="phone_number"
                        [value]="recommenderForm.get('phone_number').value" required>
                    </tel-input>
                    <mat-icon matSuffix class="secondary-text">phone</mat-icon>
                    <mat-error *ngIf="checkServerError('phone_number')"> {{checkServerError('phone_number')}}</mat-error>
                </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field appearance="outline" fxFlex>
                    <mat-label>{{'Date of Birth' | translate }}</mat-label>
                    <input matInput formControlName="date_of_birth" [max]="maxDate"
                        [matDatepicker]="birthdayPicker" placeholder="{{'Set a birth date' | translate }}" matInput>
                    <mat-datepicker-toggle matSuffix [for]="birthdayPicker">
                    </mat-datepicker-toggle>
                    <mat-datepicker #birthdayPicker></mat-datepicker>
                    <mat-error *ngIf="checkServerError('date_of_birth')"> {{checkServerError('date_of_birth')}}</mat-error>
                </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field appearance="outline" fxFlex>
                    <mat-label>{{'Email' | translate }}</mat-label>
                    <mat-icon matSuffix class="secondary-text">email</mat-icon>
                    <input name="email" formControlName="email" matInput required>
                    <mat-error *ngIf="checkServerError('email')"> {{checkServerError('email')}}</mat-error>
                </mat-form-field>
            </div>
            <!-- <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field appearance="outline" fxFlex>
                    <mat-label>{{'Request Type' | translate }}</mat-label>
                    <mat-select formControlName="type" required #requestType (selectionChange)='checkTypeChange(requestType)'>
                        <mat-option *ngFor="let requestType of requestTypes" [value]="requestType.id">
                            {{requestType.name}}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="checkServerError('type')"> {{checkServerError('type')}}</mat-error>
                </mat-form-field>
            </div> -->
            
        </form>

    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">

        <button mat-button class="save-button text-uppercase" (click)="createRecommendation(recommenderForm)" [disabled]="recommenderForm.invalid"
            aria-label="SAVE">
            {{'Add' | translate }}
        </button>

    </div>
</div>